import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({
    baseURL: BASE,
    timeout: 60000,
});

api.interceptors.request.use((config) => {
    const t = localStorage.getItem("fx_token");
    if (t) config.headers.Authorization = `Bearer ${t}`;
    return config;
});

export const adminApi = axios.create({
    baseURL: BASE,
    timeout: 60000,
});
adminApi.interceptors.request.use((config) => {
    const t = localStorage.getItem("fx_admin_token");
    if (t) config.headers.Authorization = `Bearer ${t}`;
    return config;
});

export const fmtINR = (paise) => `₹${(Number(paise || 0) / 100).toLocaleString("en-IN", { maximumFractionDigits: 2 })}`;
export const fmtINRRupees = (rupees) => `₹${Number(rupees || 0).toLocaleString("en-IN", { maximumFractionDigits: 2 })}`;
export const fmtPoints = (p) => `${Number(p || 0).toLocaleString("en-IN")} pts`;

export default api;
